module.exports = __webpack_public_path__ + "static/img/数据恢复工具模块(DE).59accbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/数据恢复工具模块(DE).png
// module id = j2mS
// module chunks = 1